import { render, staticRenderFns } from "./EditBranchComponent.vue?vue&type=template&id=e7637e88&scoped=true"
import script from "./EditBranchComponent.vue?vue&type=script&lang=js"
export * from "./EditBranchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7637e88",
  null
  
)

export default component.exports